import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { buildScheduledBroadcast, useAddScheduledBroadcast, } from '../state/scheduleState';
import { useSetStreamDirectionCallback } from '../state/streamState';
import { generateStreamPartId, getStreamPathname } from '../utils/url';
export function useGoLiveNow() {
    const setStreamDirection = useSetStreamDirectionCallback();
    const addBroadcast = useAddScheduledBroadcast();
    const navigate = useNavigate();
    return useCallback((options = {}) => {
        const { streamPartId, saveBroadcast } = options;
        const finalStreamPartId = streamPartId || generateStreamPartId();
        // Save broadcast for later access
        if (saveBroadcast) {
            addBroadcast(buildScheduledBroadcast({
                name: 'Instant broadcast',
                startsAt: new Date().getTime(),
                streamPartId: finalStreamPartId,
            }));
        }
        setStreamDirection(finalStreamPartId, 'outgoing');
        navigate(getStreamPathname(finalStreamPartId));
    }, [navigate, setStreamDirection, addBroadcast]);
}
